export const SKUS_GET_REQUEST = "@skus.get.request";
export const SKUS_GET_SUCCESS = "@skus.get.success";
export const SKUS_GET_FAIL = "@skus.get.failure";
export const SKUS_GET_DONE = "@skus.get.done";

export const SKU_LOAD_REQUEST = "@sku.load.request";
export const SKU_LOAD_SUCCESS = "@sku.load.success";
export const SKU_LOAD_FAIL = "@sku.load.failure";

export const SKU_CREATE_REQUEST = "@sku.create.request";
export const SKU_CREATE_SUCCESS = "@sku.create.success";
export const SKU_CREATE_FAIL = "@sku.create.failure";
export const SKU_CREATE_DONE = "@sku.create.done";

export const SKU_UPDATE_REQUEST = "@sku.update.request";
export const SKU_UPDATE_SUCCESS = "@sku.update.success";
export const SKU_UPDATE_FAIL = "@sku.update.failure";
export const SKU_UPDATE_DONE = "@sku.update.done";
